import React, { createContext, useContext, useState } from 'react';

const BackgroundContext = createContext();

export const BackgroundProvider = ({ children }) => {
  const [theme, setTheme] = useState({
    background: 'white', // Default background
    fontColor: '#2e2e2e',  // Default font color
  });

  const setThemeByName = (themeName) => {
    const themes = {
      redTheme: { background: '#ed243b', fontColor: 'white' },
      darkTheme: { background: '#2e2e2e', fontColor: 'white' },
      lightTheme: { background: 'white', fontColor: '#2e2e2e' },
    };

    setTheme(themes[themeName] || { background: 'white', fontColor: '#2e2e2e' });
  };

  const getHoverStyles = () => {
    if(theme.background === '#ed243b') {
      return { background: 'white', fontColor: '#ed243b'}; //Red theme
    } else if (theme.background === '#2e2e2e') {
      return { background: 'white', fontColor: '#2e2e2e' }; //Dark theme
    } else if (theme.background === 'white') {
      return { background: '#2e2e2e', fontColor: 'white' }; //Light theme
    }
    return { background: '#2e2e2e', fontColor: 'white' }; //Default
  };

  return (
    <BackgroundContext.Provider value={{ theme, setThemeByName, getHoverStyles }}>
      {children}
    </BackgroundContext.Provider>
  );
};

export const useBackground = () => useContext(BackgroundContext);